import { default as _91_46_46_46path_93eikv3LgcSwMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/[...path].vue?macro=true";
import { default as favouriteshWze5NFfIQMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/account/favourites.vue?macro=true";
import { default as passwordS0Rkycl1EDMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/account/password.vue?macro=true";
import { default as personal_45detailsxHkjsOpZ4rMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/account/personal-details.vue?macro=true";
import { default as ticketsumrx0d1JhEMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/account/tickets.vue?macro=true";
import { default as cartWNMBiuRLfdMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/cart.vue?macro=true";
import { default as checkoutUIg6fvS98dMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/checkout.vue?macro=true";
import { default as deals72Y66RtFzQMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/deals.vue?macro=true";
import { default as _91_46_46_46token_93J9cupAVw4nMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/email-change/[...token].vue?macro=true";
import { default as _91_46_46_46token_93UQ7t2rWThMMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/email-verification/[...token].vue?macro=true";
import { default as indexK3vQQiwQkaMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/email-verification/index.vue?macro=true";
import { default as check6dKlfsQvBJMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/gift-cards/check.vue?macro=true";
import { default as _91token_93AGrJxz960hMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/guest-data/[token].vue?macro=true";
import { default as indexFMytyctzIFMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/index.vue?macro=true";
import { default as order_45confirmationUlHEQJXRHTMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/order-confirmation.vue?macro=true";
import { default as hotelALpSKG16ffMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/package/hotel.vue?macro=true";
import { default as _91token_93dXZqHxFKYTMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/rate-us/[token].vue?macro=true";
import { default as _91token_93UEzuUqW2uaMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/reset-password/[token].vue?macro=true";
import { default as revalidate3SDKBJRrQbMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/revalidate.vue?macro=true";
import { default as searchknMwjFcCAyMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/search.vue?macro=true";
import { default as seat_45widgetKUhMRq3z2zMeta } from "/builds/connection-ticketing/boats-spa/web-app/pages/seat-widget.vue?macro=true";
import { default as component_45stubjmm6JR8OD6Meta } from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubjmm6JR8OD6 } from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "path",
    path: "/:path(.*)*",
    meta: _91_46_46_46path_93eikv3LgcSwMeta || {},
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/[...path].vue")
  },
  {
    name: "account-favourites",
    path: "/account/favourites",
    meta: favouriteshWze5NFfIQMeta || {},
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/account/favourites.vue")
  },
  {
    name: "account-password",
    path: "/account/password",
    meta: passwordS0Rkycl1EDMeta || {},
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/account/password.vue")
  },
  {
    name: "account-personal-details",
    path: "/account/personal-details",
    meta: personal_45detailsxHkjsOpZ4rMeta || {},
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/account/personal-details.vue")
  },
  {
    name: "account-tickets",
    path: "/account/tickets",
    meta: ticketsumrx0d1JhEMeta || {},
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/account/tickets.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/checkout.vue")
  },
  {
    name: "deals",
    path: "/deals",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/deals.vue")
  },
  {
    name: "email-change-token",
    path: "/email-change/:token(.*)*",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/email-change/[...token].vue")
  },
  {
    name: "email-verification-token",
    path: "/email-verification/:token(.*)*",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/email-verification/[...token].vue")
  },
  {
    name: "email-verification",
    path: "/email-verification",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/email-verification/index.vue")
  },
  {
    name: "gift-cards-check",
    path: "/gift-cards/check",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/gift-cards/check.vue")
  },
  {
    name: "guest-data-token",
    path: "/guest-data/:token()",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/guest-data/[token].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/index.vue")
  },
  {
    name: "order-confirmation",
    path: "/order-confirmation",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/order-confirmation.vue")
  },
  {
    name: "package-hotel",
    path: "/package/hotel",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/package/hotel.vue")
  },
  {
    name: "rate-us-token",
    path: "/rate-us/:token()",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/rate-us/[token].vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/reset-password/[token].vue")
  },
  {
    name: "revalidate",
    path: "/revalidate",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/revalidate.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/search.vue")
  },
  {
    name: "seat-widget",
    path: "/seat-widget",
    component: () => import("/builds/connection-ticketing/boats-spa/web-app/pages/seat-widget.vue")
  },
  {
    name: component_45stubjmm6JR8OD6Meta?.name,
    path: "/basket",
    component: component_45stubjmm6JR8OD6
  },
  {
    name: component_45stubjmm6JR8OD6Meta?.name,
    path: "/about",
    component: component_45stubjmm6JR8OD6
  },
  {
    name: component_45stubjmm6JR8OD6Meta?.name,
    path: "/account",
    component: component_45stubjmm6JR8OD6
  },
  {
    name: component_45stubjmm6JR8OD6Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubjmm6JR8OD6
  }
]